import { spacing, color } from '@upstox/upstox-ui';

export const overlay: CSSFunction = ({ theme }) => ({
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  background: color(theme, theme.modals.backgroundBackdrop),
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  zIndex: 3,
});
